import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

export default class ConfirmationModal extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = { showModal: this.props.showModal };
    this.close = this.close.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({ showModal: newProps.showModal });
  }

  close() {
    this.setState({ showModal: false });
    this.props.onClose();
  }

  handleConfirm() {
    this.close();
    this.props.onConfirm();
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body><p>{this.props.message}</p></Modal.Body>

        <Modal.Footer>
          <Button onClick={this.close}>{this.props.cancelText}</Button>

          <Button bsStyle={this.props.confirmClass} onClick={this.handleConfirm}>
            {this.props.confirmText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showModal: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  confirmClass: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  onClose: () => true,
  showModal: false,
  title: 'Confirmation',
  message: 'Are you sure you want to continue?',
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  confirmClass: 'primary',
};
